import React from 'react'
import styled, { keyframes } from 'styled-components'
import { random } from 'lodash/fp'

import AspectRatio from './AspectRatio'
import AssetBoltLarge from '../assets/images/bolt--large.png'
import AssetBoltSmall from '../assets/images/bolt--small.png'
import AssetSparks from '../assets/images/sparks.gif'

const sparkMovement = keyframes`
  // Half speed:
  // 0%   { transform: translate(-50%, 0)  scale(0.0); opacity: 1; }
  // 10%  { transform: translate(-50%, 0)  scale(0.0); opacity: 1; }
  // 12.5%  { transform: translate(-50%, 0)  scale(0.1); opacity: 1; }
  // 20%  { transform: translate(-50%, 5%) scale(0.6); opacity: 1; }
  // 30%  { transform: translate(-50%, 5%) scale(0.6); opacity: 1; }
  // 37.75%  { transform: translate(-50%, 0%) scale(0.1); opacity: 1; }
  // 40%  { transform: translate(-50%, 0%) scale(0.0); opacity: 1; }
  // 100% { transform: translate(-50%, 0%) scale(0.0); opacity: 1; }
  0%   { transform: translate(-50%, 0)  scale(0.0); opacity: 1; }
  20%  { transform: translate(-50%, 0)  scale(0.0); opacity: 1; }
  25%  { transform: translate(-50%, 0)  scale(0.1); opacity: 1; }
  40%  { transform: translate(-50%, 5%) scale(0.6); opacity: 1; }
  60%  { transform: translate(-50%, 5%) scale(0.6); opacity: 1; }
  75%  { transform: translate(-50%, 0%) scale(0.1); opacity: 1; }
  80%  { transform: translate(-50%, 0%) scale(0.0); opacity: 1; }
  100% { transform: translate(-50%, 0%) scale(0.0); opacity: 1; }
`

const Container = styled(AspectRatio)`
  width: ${p => p.percentWidth || '35%'};
  max-width: ${p => p.theme.spacing(5)};
  display: flex;
  min-width: ${p => p.theme.spacing(2.5)};
  position: relative;
  transform: rotate(${p => p.rotation});
  transform-origin: bottom center;
  // pointer-events: auto;

  &:hover {
    outline: 3px solid #f0f;
  }
`

const Origin = styled.div`
  display: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 5px;
  height: 5px;
  background-color: lime;

  ${Container}:hover & {
    display: block;
  }
`

const shakingMovement = keyframes`
  0%   { transform: translate(1px, 1px) }
  30%  { transform: translate(0px, 1px) }
  60%  { transform: translate(1px, 0)   }
  100% { transform: translate(0px, 0px) }
`

const ShakingContainer = styled.div`
  animation: ${shakingMovement} 200ms infinite;
`

const BoltContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(${p => p.rotation});
  transform-origin: top left;
  width: 100%;
  height: 100%;
`

const BoltImage = styled.img`
  animation: ${sparkMovement} ${p => p.duration}ms infinite ease-in-out;
  opacity: 0;
  transform-origin: top center;
  margin-top: 20%;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.05))
    drop-shadow(0 0 1px rgba(0, 0, 0, 0.2));
`

const BoltSmall = styled(BoltImage)`
  animation-delay: ${p => p.delay}ms;
  width: 35%;
`

const BoltLarge = styled(BoltImage)`
  animation-delay: ${p => p.delay}ms;
  width: 45%;
`

const Sparks = styled.img`
  width: 100%;
`

const AnimatedSparking = ({
  rotation = 0,
  duration = 1700,
  delay = 0,
  ...props
}) => {
  return (
    <Container width={1} height={1} rotation={`${rotation}deg`} {...props}>
      <BoltContainer rotation="0deg">
        <Origin />
        <ShakingContainer>
          <BoltSmall src={AssetBoltSmall} duration={duration} delay={delay} />
        </ShakingContainer>
      </BoltContainer>
      <BoltContainer rotation="-45deg">
        <Origin />
        <ShakingContainer>
          <BoltLarge src={AssetBoltLarge} duration={duration} delay={delay} />
        </ShakingContainer>
      </BoltContainer>
      <BoltContainer rotation="-90deg">
        <Origin />
        <ShakingContainer>
          <BoltSmall src={AssetBoltSmall} duration={duration} delay={delay} />
        </ShakingContainer>
      </BoltContainer>
    </Container>
  )
  return (
    <Container
      width={272}
      height={203}
      rotation={`${rotation + 150}deg`}
      {...props}
    >
      <Origin />
      <Sparks src={AssetSparks} />
    </Container>
  )
}

export default AnimatedSparking



// WEBPACK FOOTER //
// ./src/components/AnimatedSparking.js